import { useContext } from 'react';
import { ComponentContext } from '../context';

export function useComponents() {
  const context = useContext(ComponentContext);
  return { ...context };
}
